window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
// window.axios = require('axios');

window.addEventListener("load", function() {
    document.body.classList.remove('stop-animation');
    document.body.removeAttribute('class');
}, false);

// Vue
import { createApp } from 'vue'
import mitt from 'mitt'

import LogoCarousel from "./components/LogoCarousel";
import YoutubeVideoButton from "./components/YoutubeVideoButton";

const emitter = mitt()
const app = createApp({
    components: {
        LogoCarousel,
        YoutubeVideoButton
    }
})

app.config.globalProperties.emitter = emitter

if (document.querySelector('#app') !== null) {
    app.mount('#app')
}
